import React from "react";
import Hero from "../components/hero";
import Services from "../components/services";
import LastNews from "../components/LastNews";
import Projects from "../components/Projects";
import Contact from "../components/contact";
import Footer from "../components/footer";

function Home(){
    return(
        <>
        <Hero />
        <Services />
        <LastNews />
        <Projects />
        <Contact />
        <Footer />

        </>
    )
}


export default Home ; 